module.exports = __webpack_public_path__ + "CITROEN-logo.png";